var React = require('react');

function ToggleArrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #0c2761;\n        stroke-linecap: round;\n        stroke-width: 4px;\n      }\n    ")),React.createElement("path",{"id":"Path_146","data-name":"Path 146","className":"cls-1","d":"M18445,1436.271v14.577h14.576","transform":"translate(-14055.353 12040.123) rotate(-45)","key":1})]);
}

ToggleArrow.defaultProps = {"width":"26.271","height":"26.271","viewBox":"0 0 26.271 26.271"};

module.exports = ToggleArrow;

ToggleArrow.default = ToggleArrow;
